import React, { PureComponent } from 'react';

export default class PlainLeague extends PureComponent {
	static defaultProps = {
		showName: true
	};

	constructor(props) {
		super(props);
		const { league, onClick } = this.props;
		this.onClick = onClick ? onClick.bind(null, league) : null;
	}

	render() {
		const { league, name, showDivision, showName, divisionOverride } = this.props;

		if(!league) {
			return null;
		}
		const nameToBe = name || league.name;
		const divisionIsVisible = showDivision && ((league.division && !league.isUnranked()) || divisionOverride);
		return (
			<div
				onClick={this.onClick}
				className={`logo_container ${league.isUnranked() ? 'tier_ladder_league_unranked' : ''}`}>
				<div>
					<img className='tier_logo'
					     src={league.image_url} />
				</div>
				{(nameToBe || divisionIsVisible) &&
				<div className='tier_details'>
					<React.Fragment>
						{showName && nameToBe &&
						<span className='tier_name'>{nameToBe}{' '}</span>
						}
						{divisionIsVisible &&
						<span className='division'>{divisionOverride || league.division}</span>
						}
					</React.Fragment>
				</div>
				}
			</div>
		);
	}
}